export enum BundleKey {
  LOGIN_INPUT_EMAIL_PLACEHOLDER = "login.input.email.placeholder",
  LOGIN_INPUT_EMAIL_ERROR = "login.input.email.error",
  LOGIN_INPUT_EMAIL_ERROR_MUST = "login.input.email.error.must",
  LOGIN_INPUT_PASSWORD_PLACEHOLDER = "login.input.password.placeholder",
  LOGIN_INPUT_PASSWORD_ERROR = "login.input.password.error",
  LOGIN_INPUT_PASSWORD_ERROR_MUST = "login.input.password.error.must",
  LOGIN_BUTTON_LOGIN = "login.button.login",
  LOGIN_ERROR = "login.error",
  LOGIN_BUTTON_CONTACT = "login.button.contact",
  LOGIN_LABEL_FORGOTPASS = "login.label.forgotpass",
  LANG_SPANISH = "lang.spanish",
  LANG_ENGLISH = "lang.english",
  LANG_PORTUGUESE = "lang.portuguese",
  LANG = "lang",
  INPUT_DATE_PLACEHOLDER = "input.date.placeholder",
  PLACEHOLDER_VEHICLE_PLATE = "placeholder.vehicle.plate",
  PLACEHOLDER_INSURANCE_POLICY_NUMBER = "placeholder.insurance.policyNumber",
  PLACEHOLDER_FIRSTNAME = "placeholder.firstname",
  PLACEHOLDER_LASTNAME = "placeholder.lastname",
  PLACEHOLDER_DOCUMENT_NUMBER = "placeholder.document.number",
  PLACEHOLDER_EMAIL = "placeholder.email",
  PLACEHOLDER_CELLPHONE = "placeholder.cellphone",
  MENU_MANUALINPUT = "menu.manualInput",
  MENU_SCAN = "menu.scan",
  MENU_AWAITINGREQUEST = "menu.awaitingRequest",
  MENU_REGISTEREXIT = "menu.registerExit",
  LOGOUT_MESSAGE = "logout.message",
  LOGOUT_TITLE = "logout.title",
  LOGOUT_EXPIRE_TITLE = "logout.expiresession.title",
  LOGOUT_EXPIRE_MESSAGE = "logout.expiresession.message",
  ACTION_APPROVE = "action.approve",
  ACTION_CANCEL = "action.cancel",
  ACTION_ACCEPT = "action.accept",
  ACTION_YES = "action.yes",
  ACTION_NO = "action.no",
  ACTION_REJECT = "action.reject",
  ACTION_ADD = "action.add",
  ACTION_SAVE = "action.save",
  ACTION_UPDATE = "action.update",
  ACTION_SELECT = "action.select",
  ACTION_EXIT = "action.exit",
  ACTION_FINALIZE = "action.finalize",
  ACTION_EMPTY = "action.empty",
  ACCESSCARD_TITLE = "accessCard.title",
  ACCESSCARD_SUBTITLE = "accessCard.subtitle",
  ACCESSCARD_ENTRADAS = "accessCard.entradas",
  ACCESSCARD_SALIDAS = "accessCard.salidas",
  EXITCARD_PEOPLE_INSIDE = "exitCard.peopleInside",
  EXITCARD_TOTAL_PEOPLE = "exitCard.totalPeople",
  EXITCARD_MARK_EXIT = "exitCard.markExit",
  EXITUSERINPUT_SEARCH_PLACEHOLDER = "exitUserInput.search.placeholder",
  EXITUSERINPUT_REGISTER_EXIT_WITHOUT_CHECKIN = "exitUserInput.registerExitWithoutCheckin",
  PEOPLEFILTERS_SEARCH_LABEL = "peopleFilters.search.label",
  PEOPLEFILTERS_SEARCH_PLACEHOLDER = "peopleFilters.search.placeholder",
  PEOPLEFILTERS_COMPANY_LABEL = "peopleFilters.company.label",
  PEOPLEFILTERS_COMPANY_PLACEHOLDER = "peopleFilters.company.placeholder",
  PEOPLEFILTERS_TRANSPORT_COMPANY_LABEL = "peopleFilters.transportCompany.label",
  PEOPLEFILTERS_TRANSPORT_COMPANY_PLACEHOLDER = "peopleFilters.transportCompany.placeholder",
  PEOPLEFILTERS_AUTHORIZATION_LABEL = "peopleFilters.authorization.label",
  PEOPLEFILTERS_AUTHORIZATION_PLACEHOLDER = "peopleFilters.authorization.placeholder",
  CREDENTIALSCARD_SCAN = "credentialsCard.scan",
  MANUALINPUT_DNI = "manualInput.dni",
  MANUALINPUT_COUNTRY = "manualInput.country",
  MANUALINPUT_SUBMIT = "manualInput.submit",
  MANUALINPUT_SEPARATOR = "manualInput.separator",
  DIALOG_FOREIGN_MESSAGE = "dialog.foreign.message",
  DIALOG_FOREIGN_TITLE = "dialog.foreign.title",
  DIALOG_QREXPIRE_MESSAGE = "dialog.qrexpire.message",
  DIALOG_QREXPIRE_TITLE = "dialog.qrexpire.title",
  DIALOG_LEAVEENTRY_MESSAGE = "dialog.leaveDetailEntry.message",
  DIALOG_LEAVEENTRY_TITLE = "dialog.leaveDetailEntry.title",
  DIALOG_LEAVEENTRY_ACTION = "dialog.leaveDetailEntry.action",
  DIALOG_CONFIRMEXIT_TITLE = "dialog.confirmExit.title",
  DIALOG_CONFIRMEXIT_MESSAGE = "dialog.confirmExit.message",
  DIALOG_CONFIRMEXIT_DATA_ENTRY_TIME = "dialog.confirmExit.data.entryTime",
  DIALOG_CONFIRMEXIT_DATA_LOT = "dialog.confirmExit.data.lot",
  DIALOG_CONFIRMEXIT_DATA_EXIT_TIME = "dialog.confirmExit.data.exitTime",
  TYPE_VISITOR = "type.visitor",
  TYPE_RESIDENT = "type.resident",
  TYPE_COMPANION = "type.companion",
  TYPE_PROVIDER = "type.provider",
  TYPE_DRIVER = "type.driver",
  DIALOG_REJECTENTRY_MESSAGE = "dialog.rejectDetailEntry.message",
  DIALOG_COMPANIONENTRY_MESSAGE = "dialog.companionDetailEntry.message",
  DIALOG_COMPANIONENTRY_TITLE = "dialog.companionDetailEntry.title",
  DIALOG_FIELDMISSING_TITLE = "dialog.fieldMissing.title",
  DIALOG_MULTIPLEEXIT_TITLE = "dialog.multipleExit.title",
  DIALOG_MULTIPLEEXIT_DESTINATION_TITLE = "dialog.multipleExit.destination.title",
  DIALOG_MULTIPLEEXIT_TAGDRIVER_DRIVER = "dialog.multipleExit.tagdriver.driver",
  DIALOG_MULTIPLEEXIT_TAGDRIVER_COMPANION = "dialog.multipleExit.tagdriver.companion",
  DIALOG_COMPANION_ALREADYLOADED = "dialog.companion.alreadyLoaded",
  ERROR_PERSONALINF_MUST = "error.personalInf.must",
  ERROR_DNI_MUST = "error.dni.must",
  ERROR_DNI_MUST_COMPLETE = "error.dni.must.complete",
  ERROR_FIRSTNAME_MUST_COMPLETE = "error.firstname.must.complete",
  ERROR_LASTNAME_MUST_COMPLETE = "error.lastname.must.complete",
  ERROR_FIRSTNAME_MUST = "error.firstname.must",
  ERROR_LASTNAME_MUST = "error.lastname.must",
  ERROR_COUNTRY_MUST = "error.country.must",
  ERROR_METHOD_MUST = "error.method.must",
  ERROR_PASS_MUST = "error.pass.must",
  ERROR_PROVIDER_MUST = "error.provider.must",
  ERROR_VEHICLE_SELECT = "error.vehicle.select",
  ERROR_VEHICLE_PLATE_MUST = "error.vehicle.plate.must",
  ERROR_VEHICLE_LICENSE_MUST = "error.vehicle.license.must",
  ERROR_BLACKLIST_REPONSIBLE = "error.blacklist.reponsible.must",
  ERROR_CRIMINALRECORD_DATE = "error.criminalrecord.date.must",
  ERROR_CAMERA_NOTFOUND = "error.camera.notfound",
  ERROR_DATE_INVALID = "error.date.invalid",
  ERROR_DATE_INVALID_MUST = "error.date.invalid.must",
  WORD_MODEL = "word.model",
  WORD_PLATE = "word.plate",
  DETAIL_MAIN_TITLE_EXIT = "detailExit.main.title",
  DETAIL_ENTRYMETHOD_TITLE_EXIT = "detailExit.entryMethod.title",
  DETAIL_MAIN_TITLE = "detailEntry.main.title",
  DETAIL_PERSONALINF_TITLE = "detailEntry.personalInf.title",
  DETAIL_PERSONALINF_PROFILEPHOTO = "detailEntry.personalInf.profilePhoto",
  DETAIL_PERSONALINF_DNIFRONTPHOTO = "detailEntry.personalInf.dniFrontPhoto",
  DETAIL_PERSONALINF_DNIBACKPHOTO = "detailEntry.personalInf.dniBackPhoto",
  DETAIL_PERSONALINF_FIRSTNAME = "detailEntry.personalInf.firstname",
  DETAIL_PERSONALINF_LASTNAME = "detailEntry.personalInf.lastname",
  DETAIL_PERSONALINF_COUNTRY = "detailEntry.personalInf.country",
  DETAIL_PERSONALINF_DNI = "detailEntry.personalInf.dni",
  DETAIL_PERSONALINF_RESIDENT = "detailEntry.personalInf.resident",
  DETAIL_PERSONALINF_TYPEFULL = "detailEntry.personalInf.typeFull",
  DETAIL_PERSONALINF_TYPEBASIC = "detailEntry.personalInf.typeBasic",
  DETAIL_PERSONALINF_TYPEMRZ = "detailEntry.personalInf.typeMRZ",
  DETAIL_PERSONALINF_TYPEEXPRESS = "detailEntry.personalInf.typeExpress",
  DETAIL_PERSONALINF_PREVALIDATE_SUCCESS = "detailEntry.personalInf.prevalidate.success",
  DETAIL_PERSONALINF_PREVALIDATE_DENIED = "detailEntry.personalInf.prevalidate.denied",
  DETAIL_SHOWIMAGE_EDIT = "detailEntry.showimage.edit",
  DETAIL_SHOWIMAGE_CAPTURE = "detailEntry.showimage.capture",
  DETAIL_AUTHORIZATION_TITLE = "detailEntry.authorization.title",
  DETAIL_AUTHORIZATION_HIDE = "detailEntry.authorization.hide",
  DETAIL_AUTHORIZATION_SEARCH_PLACEHOLDER = "detailEntry.authorization.search.placeholder",
  DETAIL_AUTHORIZATION_SEARCH_NOTFOUND = "detailEntry.authorization.search.notfound",
  DETAIL_AUTHORIZATION_CURRENT_TITLE = "detailEntry.authorization.current.title",
  DETAIL_AUTHORIZATION_LAST_TITLE = "detailEntry.authorization.last.title",
  DETAIL_AUTHORIZATION_PENDING_TITLE = "detailEntry.authorization.pending.title",
  DETAIL_AUTHORIZATION_GUARD_TITLE = "detailEntry.authorization.guard.title",
  DETAIL_AUTHORIZATION_PARTICULAR = "detailEntry.authorization.particular",
  DETAIL_AUTHORIZATION_PROVIDER = "detailEntry.authorization.provider",
  DETAIL_PROVIDER_TITLE = "detailEntry.provider.title",
  DETAIL_PROVIDER_TYPE_PLACEHOLDER = "detailEntry.provider.type.placeholder",
  DETAIL_PROVIDER_TOOLS_PLACEHOLDER = "detailEntry.provider.tools.placeholder",
  DETAIL_PROVIDER_ACCIDENTS_TITLE = "detailEntry.provider.accidents.title",
  DETAIL_PROVIDER_ACCIDENTS_COMPANY_PLACEHOLDER = "detailEntry.provider.accidents.company.placeholder",
  DETAIL_PROVIDER_ACCIDENTS_NUMBER_PLACEHOLDER = "detailEntry.provider.accidents.number.placeholder",
  DETAIL_PROVIDER_ACCIDENTS_DATE_PLACEHOLDER = "detailEntry.provider.accidents.date.placeholder",
  DETAIL_PROVIDER_ACCIDENTS_DATE_ERROR = "detailEntry.provider.accidents.date.error",
  DETAIL_PROVIDER_ACCIDENTS_FIRSTPHOTO = "detailEntry.provider.accidents.firstPhoto",
  DETAIL_PROVIDER_ACCIDENTS_SECONDPHOTO = "detailEntry.provider.accidents.secondPhoto",
  DETAIL_PROVIDER_ANTECEDENT_TITLE = "detailEntry.provider.antecedent.title",
  DETAIL_PROVIDER_ANTECEDENT_DATE_PLACEHOLDER = "detailEntry.provider.antecedent.date.placeholder",
  DETAIL_PROVIDER_ANTECEDENT_FIRSTPHOTO = "detailEntry.provider.antecedent.firstPhoto",
  DETAIL_PROVIDER_ANTECEDENT_SECONDPHOTO = "detailEntry.provider.antecedent.secondPhoto",
  DETAIL_ENTRYMETHOD_TITLE = "detailEntry.entryMethod.title",
  DETAIL_ENTRYMETHOD_FOOT = "detailEntry.entryMethod.foot",
  DETAIL_ENTRYMETHOD_CAR = "detailEntry.entryMethod.car",
  DETAIL_ENTRYMETHOD_BICYCLE = "detailEntry.entryMethod.bicycle",
  DETAIL_ENTRYMETHOD_BICYCLE_PHOTO = "detailEntry.entryMethod.bicycle.photo",
  DETAIL_ENTRYMETHOD_CAR_ADD = "detailEntry.entryMethod.car.add",
  DETAIL_ENTRYMETHOD_CAR_INSURANCE_TITLE = "detailEntry.entryMethod.car.insurance.title",
  DETAIL_ENTRYMETHOD_CAR_INSURANCE_DATE = "detailEntry.entryMethod.car.insurance.date",
  DETAIL_ENTRYMETHOD_CAR_INSURANCE_DATE_ERROR = "detailEntry.entryMethod.car.insurance.date.error",
  DETAIL_ENTRYMETHOD_CAR_INSURANCE_PLATE = "detailEntry.entryMethod.car.insurance.plate",
  DETAIL_ENTRYMETHOD_CAR_INSURANCE_BRAND = "detailEntry.entryMethod.car.insurance.brand",
  DETAIL_ENTRYMETHOD_CAR_INSURANCE_COMPANY = "detailEntry.entryMethod.car.insurance.company",
  DETAIL_ENTRYMETHOD_CAR_INSURANCE_POLICY_NUMBER = "detailEntry.entryMethod.car.insurance.policyNumber",
  DETAIL_ENTRYMETHOD_CAR_INSURANCE_MODEL = "detailEntry.entryMethod.car.insurance.model",
  DETAIL_ENTRYMETHOD_CAR_INSURANCE_COLOR = "detailEntry.entryMethod.car.insurance.color",
  DETAIL_ENTRYMETHOD_CAR_INSURANCE_PHOTO = "detailEntry.entryMethod.car.insurance.photo",
  DETAIL_ENTRYMETHOD_CAR_TYPE = "detailEntry.entryMethod.car.type",
  DETAIL_ENTRYMETHOD_CAR_TYPE_AUTO = "detailEntry.entryMethod.car.type.auto",
  DETAIL_ENTRYMETHOD_CAR_TYPE_TRUCK = "detailEntry.entryMethod.car.type.truck",
  DETAIL_ENTRYMETHOD_CAR_TYPE_MOTO = "detailEntry.entryMethod.car.type.moto",
  DETAIL_ENTRYMETHOD_CAR_DOCUMENT_IDPHOTO = "detailEntry.entryMethod.car.document.idPhoto",
  DETAIL_ENTRYMETHOD_CAR_VTV_PHOTO = "detailEntry.entryMethod.car.vtv.photo",
  DETAIL_ENTRYMETHOD_CAR_VTV_EXPIRATION_DATE = "detailEntry.entryMethod.car.vtv.expirationDate",
  DETAIL_ENTRYMETHOD_CAR_LICENSE_TITLE = "detailEntry.entryMethod.car.license.title",
  DETAIL_ENTRYMETHOD_CAR_LICENSE_DATE = "detailEntry.entryMethod.car.license.date",
  DETAIL_ENTRYMETHOD_CAR_LICENSE_DATE_ERROR = "detailEntry.entryMethod.car.license.date.error",
  DETAIL_ENTRYMETHOD_CAR_LICENSE_FRONTPHOTO = "detailEntry.entryMethod.car.license.frontPhoto",
  DETAIL_ENTRYMETHOD_CAR_LICENSE_BACKPHOTO = "detailEntry.entryMethod.car.license.backPhoto",
  DETAIL_ENTRYMETHOD_OBSERVATION_TITLE = "detailEntry.observation.title",
  DETAIL_ENTRYMETHOD_OBSERVATION_CHILDREN = "detailEntry.observation.children",
  DETAIL_ENTRYMETHOD_OBSERVATION_DESCRIPTION = "detailEntry.observation.description",
  DETAIL_ENTRYMETHOD_OBSERVATION_PERMANENT = "detailEntry.observation.permanent",
  DETAIL_EXITMETHOD_OBSERVATION_DESCRIPTION = "detailExit.observation.description",
  DETAIL_EXITMETHOD_OBSERVATION_EXCLUSIVE = "detailExit.observation.exclusive",
  DETAIL_ENTRYMETHOD_OBSERVATION_PHOTO = "detailEntry.observation.photo",
  DETAIL_COMPATION_TITLE = "detailEntry.companion.title",
  DETAIL_COMPATION_DETAIL_TITLE = "detailEntry.companion.detail.title",
  DETAIL_COMPATION_SCAN = "detailEntry.companion.scan",
  DETAIL_COMPATION_ADD = "detailEntry.companion.add",
  DETAIL_COMPATION_SUBMIT_ADD = "detailEntry.companion.submit.add",
  DETAIL_COMPATION_ITEM_TITLE = "detailEntry.companion.item.title",
  DETAIL_COMPATION_SELFIE = "detailEntry.companion.selfie",
  DETAIL_COMPATION_FIRSTNAME = "detailEntry.companion.firstname",
  DETAIL_COMPATION_LASTNAME = "detailEntry.companion.lastname",
  DETAIL_COMPATION_DOCUMENT_COUNTRY = "detailEntry.companion.document.country",
  DETAIL_COMPATION_DOCUMENT_NUMBER = "detailEntry.companion.document.number",
  DETAIL_COMPATION_EMAIL = "detailEntry.companion.email",
  DETAIL_COMPATION_CELLPHONE = "detailEntry.companion.cellphone",
  DETAIL_COMPATION_DNI_FRONT = "detailEntry.companion.dni.front",
  DETAIL_COMPATION_DNI_BACK = "detailEntry.companion.dni.back",
  DETAIL_COMPATION_CALLOUT = "detailEntry.companion.callout",
  BLACKLIST_DESCRIPTION = "blacklist.description",
  BLACKLIST_NAME = "blacklist.name",
  BLACKLIST_LASTNAME = "blacklist.lastname",
  BLACKLIST_REASON = "blacklist.reason",
  BLACKLIST_ACTION_REJECT = "blacklist.action.reject",
  BLACKLIST_ACTION_ACCEPT = "blacklist.action.accept",
  BLACKLIST_ACTION_CONFIRM = "blacklist.action.confirm",
  BLACKLIST_AUTHORIZED_PLACEHOLDER = "blacklist.authorized.placeholder",
  REGISTEREXIT_TITLE = "registerExit.title",
  REGISTEREXIT_ACTION_MANUAL = "registerExit.action.manual",
  REGISTEREXIT_ACTION_SCAN = "registerExit.action.scan",
  REGISTEREXIT_SEARCH_PLACEHOLDER = "registerExit.search.placeholder",
  REGISTEREXIT_GRID_HEAD_LOT = "registerExit.grid.head.lot",
  REGISTEREXIT_GRID_HEAD_NANE = "registerExit.grid.head.name",
  REGISTEREXIT_GRID_HEAD_DNI = "registerExit.grid.head.dni",
  REGISTEREXIT_GRID_HEAD_PLATE = "registerExit.grid.head.plate",
  REGISTEREXIT_GRID_HEAD_DATE = "registerExit.grid.head.date",
  REGISTEREXIT_GRID_HEAD_OBSERVATIONS = "registerExit.grid.head.observations",
  REGISTEREXIT_GRID_LOADING = "registerExit.grid.loading",
  REGISTEREXIT_NOTFOUND = "registerExit.notfound",
  PENDINGREQUEST_TITLE = "pendingRequest.title",
  PENDINGREQUEST_NOTFOUND = "pendingRequest.notfound",
  PENDINGREQUEST_SEARCH_PLACEHOLDER = "pendingRequest.search.placeholder",
  PENDINGREQUEST_ACTION_DIALOG_MESSAGE_CONFIRM = "pendingRequest.action.dialog.message.confirm",
  PENDINGREQUEST_ACTION_DIALOG_MESSAGE_REJECT = "pendingRequest.action.dialog.message.reject",
  PENDINGREQUEST_GRID_HEAD_LOT = "pendingRequest.grid.head.lot",
  PENDINGREQUEST_GRID_HEAD_RESIDENT = "pendingRequest.grid.head.resident",
  PENDINGREQUEST_GRID_HEAD_GUEST = "pendingRequest.grid.head.guest",
  PENDINGREQUEST_GRID_HEAD_DATEOFPASS = "pendingRequest.grid.head.dateofpass",
  PENDINGREQUEST_GRID_HEAD_COMMENTS = "pendingRequest.grid.head.comments",
  PENDINGREQUEST_GRID_HEAD_ACTIONS = "pendingRequest.grid.head.actions",
  PENDINGREQUEST_GRID_HEAD_LOT_TOOLTIP = "pendingRequest.grid.head.lot.tooltip",
  PENDINGREQUEST_GRID_HEAD_RESIDENT_TOOLTIP = "pendingRequest.grid.head.resident.tooltip",
  PENDINGREQUEST_GRID_HEAD_GUEST_TOOLTIP = "pendingRequest.grid.head.guest.tooltip",
  PENDINGREQUEST_GRID_HEAD_DATEOFPASS_TOOLTIP = "pendingRequest.grid.head.dateofpass.tooltip",
  PENDINGREQUEST_GRID_HEAD_COMMENTS_TOOLTIP = "pendingRequest.grid.head.comments.tooltip",
  PENDINGREQUEST_GRID_HEAD_ACTIONS_TOOLTIP = "pendingRequest.grid.head.actions.tooltip",
  TAB_HEAD_ENTRY = "tab.head.entry",
  TAB_HEAD_EXIT = "tab.head.exit",
  TAB_MULTIPLEEXIT_TITLE = "tab.multipleExit.title",
  TAB_ONHOLD_MESSAGE = "tab.onhold.message",
  TAB_ONHOLD_ACTION = "tab.onhold.action",
  TAB_MAXLIMIT_MESSAGE = "tab.maxlimit.message",
  ACTUAL_LOCATION_LABEL = "pl.header.actual_location",
  ACCESS_TYPE_FORM_TITLE = "accessTypeForm.title",
  ACCESS_TYPE_FORM_TITLE_EXIT = "accessTypeForm.exitTitle",
  ACCESS_VEHICLE_FORM_TITLE = "accessVehicleForm.title",
  ACCESS_VEHICLE_FORM_TITLE_EXIT = "accessVehicleForm.exitTitle",
  ACCESS_VEHICLE_METHOD_WALK = "accessVehicleForm.method.walk",
  ACCESS_VEHICLE_METHOD_VEHICLE = "accessVehicleForm.method.vehicle",
  ACCESS_VEHICLE_METHOD_BIKE = "accessVehicleForm.method.bike",
  ACCESS_RULES_FORM_TITLE = "accessRulesForm.title",
  ACCESS_RULES_FORM_TITLE_EXIT = "accessRulesForm.exitTitle",
  ACCESS_TYPE_FORM_SEARCH_PLACEHOLDER = "accessTypeForm.search.placeholder",
  ACCESS_TYPE_FORM_SEARCH_BUTTON = "accessTypeForm.search.button",
  ACCESS_TYPE_FORM_LOADING = "accessTypeForm.loading",
  ACCESS_TYPE_FORM_EMPTY = "accessTypeForm.empty",
  ACCESS_TYPE_FORM_PLACEHOLDER_EVENTUAL = "accessTypeForm.placeholder.eventual",
  ACCESS_TYPE_FORM_PLACEHOLDER_VISITOR = "accessTypeForm.placeholder.visitor",
  ACCESS_TYPE_FORM_PLACEHOLDER_TRANSPORT = "accessTypeForm.placeholder.transport",
  ACCESS_TYPE_CONTRACTOR_SECTION_ART_TITLE = "accessTypeForm.contractor.section.art.title",
  ACCESS_TYPE_CONTRACTOR_SECTION_CRIMINAL_TITLE = "accessTypeForm.contractor.section.criminal.title",
  ACCESS_TYPE_CONTRACTOR_PHOTO_LABEL = "accessTypeForm.contractor.photo.label",
  ACCESS_TYPE_METHOD_EVENTUAL = "accessTypeForm.method.eventual",
  ACCESS_TYPE_METHOD_CONTRACTOR = "accessTypeForm.method.contractor",
  ACCESS_TYPE_METHOD_VISITOR = "accessTypeForm.method.visitor",
  ACCESS_TYPE_METHOD_TRANSPORT = "accessTypeForm.method.transport",
  ACCESS_TYPE_TRANSPORT_DRIVER_TITLE = "accessTypeForm.transport.driver.title",
  DETAIL_ASSOCIATED_VEHICLES_TITLE = "detailEntry.associatedVehicles.title",
  DETAIL_ASSOCIATED_VEHICLES_SUBMIT_ADD = "detailEntry.associatedVehicles.submit.add",
  DETAIL_ASSOCIATED_VEHICLES_ITEM_TITLE = "detailEntry.associatedVehicles.item.title",
  VEHICLE_SEARCH_PLACEHOLDER = "vehicle.search.placeholder",
  VEHICLE_SEARCH_BUTTON = "vehicle.search.button",
  ACCESS_TYPE_FORM_AUTORIZACIONES_VIGENTES = "accessTypeForm.autorizacionesVigentes",
  ACCESS_TYPE_FORM_REGISTRAR_MANUAL = "accessTypeForm.registrarManual",
  ACCESS_TYPE_FORM_REGISTRAR_MANUAL_EXIT = "accessTypeForm.registrarManualExit",
  ACCESS_TYPE_FORM_NO_AUTORIZACIONES_VIGENTES = "accessTypeForm.noAutorizacionesVigentes",
  ACCESS_TYPE_FORM_SELECCIONADO_EN_GUARDIA = "accessTypeForm.seleccionadoEnGuardia",
  // Extension puente Raspberry (vectorizacion local)
  RB_EXT_MENU = "raspberryExtension.menu",
  RB_EXT_DOWNLOAD_ERROR = "raspberryExtension.download.error",
}

export default BundleKey;
